<script setup lang="ts">
import { computed } from 'vue'

import SettingWidth from '@/components/atoms/SettingWidth.vue'
import SettingsLayout from '@/components/layouts/SettingsLayout.vue'
import { useEditorBetaStore } from '@/stores/editor/beta'

const betaStore = useEditorBetaStore()
const elementForEdit = computed(() => betaStore.elementForEdit)

const onChangeWidth = (event: any) => {
    if (!elementForEdit.value) return

    if (event.target === 'desktop') elementForEdit.value.grid = event.value
    if (event.target === 'mobile') elementForEdit.value.gridMobile = event.value

    betaStore.updateElementForEdit()
}
</script>

<template>
    <settings-layout
        v-if="elementForEdit"
        name="Configurações do Conteúdo"
        :default-open="true"
    >
        <setting-width
            label="Largura"
            :value="elementForEdit.grid"
            :value-mobile="elementForEdit.gridMobile"
            :values-permission-desktop="[4, 6, 12]"
            :values-permission-mobile="[4, 6, 12]"
            @change="onChangeWidth"
        />
    </settings-layout>

    <div v-else class="beta-settings-empty">
        <p>Selecione uma seção ou componente para configurar.</p>
    </div>
</template>

<style scoped>
.beta-settings-empty {
    @apply rounded-2xl border border-dashed border-[#DCE5F2] bg-white px-4 py-5 text-sm leading-6 text-[#6C7E99];
}
</style>
